import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined'; // Import the tag outline icon
import { Box, Slider, Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import PropTypes from 'prop-types';
import { useState } from 'react';
import DatePicker from 'react-datepicker'; // Import react-datepicker
import 'react-datepicker/dist/react-datepicker.css'; // Import the datepicker CSS
import { getUserTasks_byPickDate } from '../../api/apiProfile';

const ProfileFooter_Tasks = ({ empUserId }) => {
  const [pickDate, setPickDate] = useState(new Date());

  const {
    data: tasks = [],
    isLoading,
    error,
  } = useQuery({
    queryKey: ['tasks', empUserId, pickDate],
    queryFn: () => getUserTasks_byPickDate(empUserId, pickDate),
    staleTime: 1000 * 60 * 5,
    cacheTime: 1000 * 60 * 10,
    enabled: !!empUserId,
  });
  console.log('tasks: ', tasks);
  const maxIncome = tasks.length ? Math.max(...tasks.map(task => task.income)) : 0;

  const totalIncome = tasks.reduce((acc, task) => acc + task.income, 0); // Calculate total income for the week

  // Function to correctly format and get the day and date
  const getDayLabel = dateString => {
    const date = new Date(dateString + 'T00:00:00'); // Ensure proper timezone conversion
    return {
      day: date.toLocaleDateString('en-US', { weekday: 'short' }).toUpperCase(),
      date: date.getDate(),
    };
  };

  if (isLoading) {
    return <p>Loading...</p>;
  }

  if (error) {
    return <p>Error loading tasks: {error.message}</p>;
  }

  return (
    <div className="profile-footer-ttasks">
      {/* Date Picker */}
      <Box
        textAlign="center"
        marginBottom={2}
        display="flex"
        justifyContent="center"
        alignItems="center"
        gap={1}
      >
        <DatePicker
          selected={pickDate}
          onChange={date => setPickDate(date)}
          maxDate={new Date()}
          dateFormat="MM/dd/yyyy"
          calendarStartDay={1}
          className="w-24 p-1 border border-gray-300 rounded ml-10"
        />

        <Typography variant="body2">
          W.Total: {totalIncome} USD {/* Display the total income for the week */}
        </Typography>
      </Box>

      {/* Task List */}
      <Box>
        {tasks.length > 0 ? (
          tasks.map((task, index) => {
            const { day, date } = getDayLabel(task.checkinTime);

            return (
              <Box
                key={index}
                display="flex"
                alignItems="center"
                padding={1}
                borderBottom="1px solid #e5e5e5"
              >
                {/* Day and Date */}
                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  justifyContent="center"
                  width="50px"
                  height="50px"
                  backgroundColor="#e8e7e7"
                  borderRadius="8px"
                  marginRight={2}
                >
                  <Typography variant="body2" fontWeight="bold">
                    {day}
                  </Typography>
                  <Typography variant="h6" fontWeight="bold">
                    {date}
                  </Typography>
                </Box>

                {/* Task Date */}
                <Box flex={1}>
                  <Typography variant="body2" minWidth={60}>
                    {new Date(task.checkinTime + 'T00:00:00').toLocaleDateString('en-US')}
                  </Typography>
                </Box>

                {/* Income with Tag Icon */}
                <Box flex={1}>
                  <Box display="flex" alignItems="center" width={100} paddingLeft={2}>
                    <LocalOfferOutlinedIcon sx={{ marginRight: 1 }} />
                    {/* Tag Icon */}
                    <Typography variant="h5" fontWeight="bold" lineHeight={1.2}>
                      {task.income}
                    </Typography>
                  </Box>
                </Box>

                {/* Income Chart */}
                <Box flex={2}>
                  <Box display="flex" alignItems="center" marginX={2}>
                    <Slider
                      value={(task.income / maxIncome) * 100}
                      max={100}
                      disabled
                      sx={{
                        color: '#3f51b5',
                        height: 8,
                        '& .MuiSlider-track': {
                          border: 'none',
                        },
                        '& .MuiSlider-thumb': {
                          height: 0,
                        },
                      }}
                    />
                  </Box>
                </Box>

                {/* Credit */}
                <Box flex={1} textAlign="right" maxWidth={40}>
                  <Typography variant="body2" fontSize="10px">
                    {'Turn'}
                  </Typography>
                  <Typography variant="body2">{task.credits || 'N/A'}</Typography>
                </Box>
              </Box>
            );
          })
        ) : (
          <Typography textAlign="center" marginTop={2} color="gray">
            Waiting for Manager to update tasks...
          </Typography>
        )}
      </Box>
    </div>
  );
};

// Add prop validation using PropTypes
ProfileFooter_Tasks.propTypes = {
  empUserId: PropTypes.string.isRequired,
};

export default ProfileFooter_Tasks;
